import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-watermark',
    templateUrl: './watermark.component.html',
    styleUrls: ['./watermark.component.scss'],
    standalone: false
})
export class WatermarkComponent implements OnInit {
  @Input() content: string;
  @Input() className?: string;
  @Input()
  set count(count: number) {
    this.itemCount = Array(count);

  };

  itemCount: Array<number>;

  constructor() { }

  ngOnInit(): void {
  }

}
